import React from 'react';
import F from "../../Functions";
import { getAutoAndHomeValue } from './helpers';

import bfileLogo from './images/B-File_logo.png'
import auto from './images/auto.png'
import home from './images/home.png'
import umbrella from './images/umbrella.png'
import insurance from './images/insurance.png'
import phone from './images/phone-call.png'
import mail from './images/mail.png'
import users from './images/users.png'

//Icons from wizard folder
// import ClassicCar from "../../scenes/Wizard/parts/images/new/classic_car.svg";
// import RV from "../../scenes/Wizard/parts/images/new/rv.svg";
// import Boat from "../../scenes/Wizard/parts/images/new/boat.svg";
// import Motorcycle from "../../scenes/Wizard/parts/images/new/motor_cycle.svg";
// import Drone from "../../scenes/Wizard/parts/images/new/drone.svg";
// import GolfCart from "../../scenes/Wizard/parts/images/new/golf_cart.svg";
// import Watercraft from "../../scenes/Wizard/parts/images/new/water_craft.svg";
// import Snowmobile from "../../scenes/Wizard/parts/images/new/snowmobile.svg";
// import OffRoad from "../../scenes/Wizard/parts/images/new/atv.svg";
// import Other from "../../scenes/Wizard/parts/images/new/other.svg";
// import SecondaryHome from "../../scenes/Wizard/parts/images/new/homeowners.svg";
// import MFGHome from "../../scenes/Wizard/parts/images/new/mfg.svg";
// import Condominium from "../../scenes/Wizard/parts/images/new/condominium.svg";
import Landlord from "../../scenes/Wizard/parts/images/bfile-landlord.svg";
// import VacantProperty from "../../scenes/Wizard/parts/images/new/vacant-land.svg";

// ong images 
import ClassicCar from "../../scenes/Wizard/parts/images/new/png-images/Classic_car.png";
import RV from "../../scenes/Wizard/parts/images/new/png-images/RV-removebg-preview.png";
import Boat from "../../scenes/Wizard/parts/images/new/png-images/Boat.png";
import Motorcycle from "../../scenes/Wizard/parts/images/new/png-images/motor-cycle-removebg-preview.png";
import Drone from "../../scenes/Wizard/parts/images/new/png-images/Drone.png";
import GolfCart from "../../scenes/Wizard/parts/images/new/png-images/Golf_Cart.png";
import Watercraft from "../../scenes/Wizard/parts/images/new/png-images/Watercraft.png";
import Snowmobile from "../../scenes/Wizard/parts/images/new/png-images/Snowmobile.png";
import OffRoad from "../../scenes/Wizard/parts/images/new/png-images/ATV.png";
import Other from "../../scenes/Wizard/parts/images/new/png-images/Others.png";
import SecondaryHome from "../../scenes/Wizard/parts/images/new/png-images/Secondary_home.png";
import MFGHome from "../../scenes/Wizard/parts/images/new/png-images/Rental.png";
import Condominium from "../../scenes/Wizard/parts/images/new/png-images/Condominium.png";
// import Landlord from "../../scenes/Wizard/parts/images/new/png-images/homeowners.png";
import VacantProperty from "../../scenes/Wizard/parts/images/new/png-images/Vacant_property.png";






const PrintableContent = React.forwardRef((props, ref) => {
  const { bfile, user, agency_owner_details, data } = props

  let pncItems = []
  let pncItems2 = []
  let pncItems3 = []




  let { recommended_limit, recommended_limit_2 } = getAutoAndHomeValue(data, bfile.liability_calculator_value, bfile.home_toggle);

  recommended_limit = bfile.auto_policy_recommended_limit ? bfile.auto_policy_recommended_limit : recommended_limit;
  recommended_limit_2 = bfile.home_policy_recommended_limit_2 ? bfile.home_policy_recommended_limit_2 : recommended_limit_2;

  const life_insurance = bfile.life_insurance_types ? bfile.life_insurance_types : bfile.home_mortgage_protection_policy ? JSON.parse(bfile.home_mortgage_protection_policy) : []
  const bfile_address = [
    bfile.address,
    bfile.address_cont,
    bfile.city,
    bfile.state,
    bfile.zipcode,
    "United States",
  ]
    .filter((value) => value)
    .join(", ") || "No Address"

  const age = bfile.birthday ? F.bfile_get_ages(bfile).join("/") : "";
  const life_stage = bfile.birthday ? F.bfile_life_stage(bfile, agency_owner_details) : { desc: "", title: "" };
  const asset_401k_accounts = bfile.asset_401k_accounts ? JSON.parse(bfile.asset_401k_accounts) : [];
  const asset_401k_accounts_spouse =
    bfile.asset_401k_accounts_spouse &&
      bfile.asset_401k_accounts_spouse !== "" &&
      bfile.asset_preservation_value_spouse !== null &&
      bfile.asset_preservation_value_spouse !== "" ? JSON.parse(bfile.asset_401k_accounts_spouse) : []

  const suggested_minimum_life_insurance = data["minimum_liability_limits_ext"] ?
    F.dollar_format(
      F.lifeInsurance(
        bfile,
        data.minimum_liability_limits_ext
      )
    ) : F.dollar_format(0);


  if (bfile.policies && bfile.policies.length > 0) {
    for (let i = 0, len = bfile.policies.length; i < len; i++) {
      F.log(bfile.policies.length);
      let icon = ""
      let item = bfile.policies[i].policy_type ? bfile.policies[i].policy_type : bfile.policies[i].type;
      if (item === "Classic Car") icon = ClassicCar;
      if (item === "RV") icon = RV;
      if (item === "Boat") icon = Boat;
      if (item === "Motorcycle") icon = Motorcycle;
      if (item === "Drone") icon = Drone;
      if (item === "Golf Cart") icon = GolfCart;
      if (item === "Water Craft") icon = Watercraft;
      if (item === "Watercraft") icon = Watercraft;
      if (item === "Snowmobile") icon = Snowmobile;
      if (item === "ATV") icon = OffRoad;
      if (item === "Off Road") icon = OffRoad;
      if (item === "Other") icon = Other;
      if (item === "Others") icon = Other;
      // if (item === "Rent") icon = SecondaryHome;
      if (item === "Secondary Home") icon = SecondaryHome;
      if (item === "MFG Home") icon = MFGHome;
      if (item === "Condominium") icon = Condominium;
      if (item === "Landlord") icon = Landlord;
      if (item === "Rentals") icon = MFGHome;
      if (item === "Vacant Property") icon = VacantProperty;
      if (item === "Umbrella") icon = umbrella;
      // F.log(cross_sell_opportunities.length);
      if (bfile.policies[i].policy_sold !== 1) {
        if (pncItems.length < 5) {
          pncItems.push({
            name: item,
            icon: icon
          });
        }
        else if (pncItems2.length < 5) {
          pncItems2.push({
            name: item,
            icon: icon
          });
        } else {
          pncItems3.push({
            name: item,
            icon: icon
          });
        }
      }
    }
  }

  return (
    <div ref={ref}>
      <div className='show-print'>
        <div className="container-wrapper-box" cellPadding="0">
          {/* Top Content */}
          <div>
            <div className="logo-container">
              <img src={bfileLogo} width={100} alt="Logo" className="agency-logo" />
            </div>
            <div>
              <h4 className="text-15">{bfile.agency && bfile.agency.name
                ? (bfile.agency.name).toUpperCase()
                : bfile.agency_info && bfile.agency_info.name ? (bfile.agency_info.name).toUpperCase()
                  : "NO NAME"}</h4>
              <div>
                <span className="text-15">Email: </span>
                <span className="email-text text-14">
                  {agency_owner_details.email
                    ? agency_owner_details.email
                    : "noemail@bfilesystem.com"}</span>{" "}
                <span className="text-15">Phone:</span>
                <span className="phone-text text-14">{agency_owner_details.phone ? F.phone_format(agency_owner_details.phone) : "(XXX) XXX-XXXX"}</span>
              </div>
            </div>

            {/* Contact Info */}
            <div className="contact-info">
              <h3 className="text-semibold contact-value margin-10 text-18">{bfile.first_name &&
                bfile.first_name + " " + bfile.last_name}</h3>
              <div className="contact-details">
                <p className="contact-text contact-label">
                  <img src={mail} alt="mail" />
                  Email:<span className="contact-value">
                    {bfile.email
                      ? bfile.email
                      : "noemail@bfilesystem.com"}</span>
                </p>
                <p className="contact-text contact-label">
                  <img src={phone} alt="phone" />
                  Phone:<span className="contact-value"> {bfile.phone ? F.phone_format(bfile.phone) : "(XXX) XXX-XXXX"}</span>
                </p>
              </div>
              <div>
                <p className="contact-text contact-label">
                  <img src={users} alt="user" />
                  Address: <span className="contact-value">{bfile_address ? bfile_address : "No Address"}</span>
                </p>
              </div>
            </div>

            {/* Risk Assessment Section */}
            <div className="risk-assessment-header text-16 contact-value">
              <h2>Intelligence Link</h2>
            </div>
            <div>
              <p className="risk-assessment-text text-14">
                Based on the information our Intelligence Link has determined that you need to protect assets in the amount of:
              </p>
            </div>
            <div className="risk-amount">
              <h1 className="text-16">{bfile.rac_calculator ? F.dollar_format(bfile.rac_calculator) : bfile.liability_calculator_value ? F.dollar_format(bfile.liability_calculator_value) : "$0"}</h1>
            </div>

            {/* Limit Section */}
            <div className="limit-container" style={{ paddingBottom: "20px" }}>
              <div style={{ width: "300px" }}>
                <h4 className="text-15 contact-value">Auto & Home limit</h4>
                <div className="limit-box">
                  <div className="limit-content">
                    <div className="text-box">
                      <img src={auto} className="icon-img" alt="Auto" />
                      <p className="text-14 myd-block">Auto</p>
                      <p className="text-14">{recommended_limit !== "$NaN" ? recommended_limit : "$0"}</p>
                    </div>
                    <div className="text-box">
                      <img src={home} className="icon-img" alt="Home" />
                      <p className="text-14 myd-block">Home</p>
                      <p className="text-14">{recommended_limit_2 !== "$NaN" ? recommended_limit_2 : "$0"}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div style={{ width: "300px" }}>
                <h4 className="text-15 contact-value">Recommended Umbrella Limit</h4>
                <div className="limit-box">
                  <div className="limit-content">
                    <div className="text-box">
                      <img src={umbrella} className="icon-img" alt="Umbrella" />
                      <p className="text-14">Umbrella</p>
                      <p className="text-14">{bfile.umbrella_limit ? F.dollar_format(bfile.umbrella_limit) : "$0"}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* P&C Items */}
            <div>
              {pncItems.length > 0 &&
                <p className="text-15 contact-value text-semibold">
                  P&C Items In The Household
                </p>
              }
              {pncItems.length > 0 && <div className="icon-container limit-box">
                {pncItems.map((item, index) => (<span className="h-center" key={index}>
                  <img src={item.icon} className="icon-img" alt={item.name} />
                  {item.name}
                </span>
                ))}
              </div>}
              {pncItems2.length > 0 && <div className="icon-container icon-box-others">
                {pncItems2.map((item, index) => (<span className="h-center" key={index}>
                  <img src={item.icon} className="icon-img" alt={item.name} />
                  {item.name}
                </span>
                ))}
              </div>}
              {pncItems3.length > 0 && <div className="icon-container icon-box-others">
                {pncItems3.map((item, index) => (<span className="h-center" key={index}>
                  <img src={item.icon} className="icon-img" alt={item.name} />
                  {item.name}
                </span>
                ))}
              </div>}
            </div>

            {/* Suggested Life Insurance */}
            <div className='make-div-centered'>
              <div className="risk-assessment-header-text">
                <p className="text-15 text-semibold contact-value">
                  Suggested Minimum Life Insurance
                </p>
              </div>
              <div className="make-div-centered">
                <div
                  className="limit-box"
                  style={{
                    width: "300px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div className="limit-content">
                    <div className="text-box">
                      <img src={insurance} className="icon-img" alt="Insurance" />
                      <p className="text-14">Insurance</p>
                      <p className="text-14">{suggested_minimum_life_insurance}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Page Break */}
          <div className="page-break"></div>
          {/* <div cellPadding="0"> */}
          <div>
            <div className="logo-container">
              <img src={bfileLogo} width={100} alt="Logo" className="agency-logo" />
            </div>
            <div>
              <h4 className="text-15">{bfile.agency && bfile.agency.name
                ? (bfile.agency.name).toUpperCase()
                : bfile.agency_info && bfile.agency_info.name ? (bfile.agency_info.name).toUpperCase()
                  : "NO NAME"}</h4>
              <div>
                <span className="text-15">Email: </span>
                <span className="email-text text-14">
                  {agency_owner_details.email
                    ? agency_owner_details.email
                    : "noemail@bfilesystem.com"}</span>{" "}
                <span className="text-15">Phone:</span>
                <span className="phone-text text-14">{agency_owner_details.phone ? F.phone_format(agency_owner_details.phone) : "(XXX) XXX-XXXX"}</span>
              </div>
            </div>

            {/* Contact Info */}
            <div className="contact-info">
              <h3 className="text-semibold contact-value margin-10 text-18">{bfile.first_name &&
                bfile.first_name + " " + bfile.last_name}</h3>
              <div className="contact-details">
                <p className="contact-text contact-label">
                  <img src={mail} alt="mail" />
                  Email:<span className="contact-value">
                    {bfile.email
                      ? bfile.email
                      : "noemail@bfilesystem.com"}</span>
                </p>
                <p className="contact-text contact-label">
                  <img src={phone} alt="phone" />
                  Phone:<span className="contact-value"> {bfile.phone ? F.phone_format(bfile.phone) : "(XXX) XXX-XXXX"}</span>
                </p>
              </div>
              <div>
                <p className="contact-text contact-label">
                  <img src={users} alt="users" />
                  Address: <span className="contact-value">{bfile_address ? bfile_address : "No Address"}</span>
                </p>
              </div>
            </div>

            <div className='table-wrapper'>
              <p className="life-stage-container text-15 contact-value text-semibold">
                Life Stage
              </p>

              <div>
                <table className="bordered-table">
                  <tbody>
                    {age !== "" && <tr>
                      <td>Age</td>
                      <td>{age}</td>
                    </tr>}
                    {bfile.children && <tr>
                      <td>Number of Children</td>
                      <td>{bfile.children}</td>
                    </tr>}
                    {bfile.home_mortgage && <tr>
                      <td>Primary Mortgage Balance</td>
                      <td>{bfile.home_mortgage}</td>
                    </tr>}
                    {bfile.secondary_home_mortgage && <tr>
                      <td>Total Additional Mortgage Balance</td>
                      <td>{bfile.secondary_home_mortgage}</td>
                    </tr>}
                    <tr>
                      <td>Life Insurance</td>
                      <td>{bfile.home_mortgage_protection_toggle &&
                        bfile.home_mortgage_protection_toggle !==
                        "0" && life_insurance.length > 0
                        ? life_insurance.join(
                          ", "
                        )
                        : "No Life Insurance"}</td>
                    </tr>
                    {life_stage.desc !== "" && life_stage.desc !== null && <tr>
                      <td>{life_stage.title}</td>
                      <td>
                        {life_stage.desc}
                      </td>
                    </tr>}
                  </tbody>
                </table>
              </div>
            </div>
            <div className='table-wrapper'>
              <p className="life-stage-container text-15 contact-value text-semibold">
                Asset Account / Retirement Opportunities
              </p>

              <div>
                <table className="bordered-table-assets-account">
                  <tbody>
                    {bfile.asset_preservation_value !== "" && bfile.asset_preservation_value !== null && <tr>
                      <td>
                        Primary {asset_401k_accounts.join(" & ")} - Value (Self)
                      </td>
                      <td>{bfile.asset_preservation_value}</td>
                    </tr>}
                    {asset_401k_accounts_spouse.length > 0 && <tr>
                      <td>
                        Secondary {asset_401k_accounts_spouse.join(" & ")} - Value
                        (Spouse's/Partner's)
                      </td>
                      <td>{bfile.asset_preservation_value_spouse}</td>
                    </tr>}
                    {bfile.employed_anual_income !== null && bfile.employed_anual_income !== "" && <tr>
                      <td>
                        Total Value of Primary Household Income (Self)
                      </td>
                      <td>{bfile.employed_anual_income}</td>
                    </tr>}
                    {bfile.employed_anual_income_spouse !== "" && bfile.employed_anual_income_spouse !== null && (<tr>
                      <td>
                        Total Value of Secondary Household Income (Spouse's/Partner's)
                      </td>
                      <td>{bfile.employed_anual_income_spouse}</td>
                    </tr>)}
                    {bfile.asset_total_value !== null && bfile.asset_total_value !== "" && <tr>
                      <td>Total Value of Primary Asset Accounts (Self)</td>
                      <td>{bfile.asset_total_value}</td>
                    </tr>}
                    {bfile.asset_total_value_spouse !== null && bfile.asset_total_value_spouse !== "" && <tr>
                      <td>
                        Total Value of Secondary Asset Accounts (Spouse's/Partner's)
                      </td>
                      <td>{bfile.asset_total_value_spouse}</td>
                    </tr>}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          {/* </div> */}

          {/* Page Break */}
          <div className="page-break"></div>
        </div>
      </div>
    </div>
  );
});

export default PrintableContent;



// WEBPACK FOOTER //
// ./src/components/print-pdf/PrintableContent.js